import './App.css';
import Header from './pages/header';
import Home from './home';
import About from './pages/about';
import Passion from './pages/passion';
import Skills from './pages/skill';
import Projects from './pages/Projects';
import Contact from './pages/contact';
import Footer from './pages/footer';
import Cursor from './pages/cursor';

function App() {
  return (
    <>
    <div >
<Cursor/>
  <Header/>
  <Home/>
  <About/>
  <Passion/>
  <Skills/>
  <Projects/>
  <Contact/>
  <Footer/>
    </div>
    </>
  );
}

export default App;
